
















import Vue from 'vue'
import { Component } from "vue-property-decorator";
import FullReferralsNested from '../../components/NestedReferrals/FullReferralsNestedTs.vue'
import { FullReferralsResponse, ReferralUser } from "@/views/chat/types";
import { cloneDeep } from 'lodash'
import store from "@/store/store";
import TableLayout from '@/views/chat/TableLayout.vue'

@Component({
  components: {
    FullReferralsNested,
    TableLayout,
  }
})
export default class FullReferralsTs extends Vue {
  gentime: string = ''

  chat_title: string = ''

  pagination = 10

  referrals: Array<ReferralUser & { indexPosition: number }> = []

  loaded = false

  getGenDate() {
    if (this.gentime) {
      return new Date(this.gentime).toLocaleDateString(this.$i18n.locale, {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      })
    }
  }

  mounted(): void {
    this.loaded = true
    this.$store.dispatch(this.$route.name === 'full-referrals' ? 'getChatReferralsList' : 'getChatActiveReferralsList', this.$route.params.id).then((res: FullReferralsResponse) => {
      this.gentime = res.gentime
      this.chat_title = res.chat_title

      this.referrals = cloneDeep(res.users)
        .sort((a, b) => b.referrals - a.referrals)
        .map((user, index) => {
          return { ...user,
            indexPosition: index + 1,
            nestedReferrals: this.getNestedReferrals(user)
          }
        })
    }).finally(() => {
      this.loaded = false
    })
  }

  getNestedReferrals(record: ReferralUser): Array<ReferralUser> {
    const fullReferrals: Array<ReferralUser> = store.state.fullReferralsUsers.slice()
    const nestedReferrals: Array<ReferralUser> = []

    if (record.referral_users) {
      record.referral_users.forEach(referral => {
        const findReferral = fullReferrals.find(user => user.user_id === referral.user_id)

        if (findReferral) {
          nestedReferrals.push({ ...findReferral })
        } else {
          nestedReferrals.push(Object.assign(referral, { referrals: 0, referral_users: [], nestedReferrals: [] }))
        }
      })
    }

    if (nestedReferrals.length) {
      nestedReferrals.forEach((nestedReferral) => {
        nestedReferral.nestedReferrals = this.getNestedReferrals(nestedReferral)
      })
    }

    return nestedReferrals
      .sort((a, b) => b.referrals - a.referrals)
      .map((user, index) => {
        return {...user, indexPosition: index + 1}
      })
  }
}
